import { defineMessages } from 'react-intl.macro';

import { EPSI_STATE } from './constants';

export const epsiMessages = defineMessages({
  title: {
    id: 'manager.epsi.title',
    defaultMessage: 'Aktualizace EPSI',
  },
  description: {
    id: 'manager.epsi.description',
    defaultMessage: 'Přehled provedených aktualizací objektů EPSI v datovém skladu IS DTM kraje.',
  },
  columnId: {
    id: 'manager.epsi.columnId',
    defaultMessage: 'ID synchronizace',
  },
  columnType: {
    id: 'manager.epsi.columnType',
    defaultMessage: 'Typ importu',
  },
  columnCreated: {
    id: 'manager.epsi.columnCreated',
    defaultMessage: 'Vytvořeno',
  },
  columnImported: {
    id: 'manager.epsi.columnImported',
    defaultMessage: 'Importováno',
  },
  columnSource: {
    id: 'manager.epsi.columnSource',
    defaultMessage: 'Zdroj dokumentace',
  },
  columnState: {
    id: 'manager.epsi.columnState',
    defaultMessage: 'Stav',
  },
  columnPspiDatumOd: {
    id: 'manager.epsi.columnPspiDatumOd',
    defaultMessage: 'Datum',
  },
  synchronizeBtn: {
    id: 'manager.epsi.synchronizeBtn',
    defaultMessage: 'Synchronizovat',
  },
  synchronizeStarted: {
    id: 'manager.epsi.synchronizeStarted',
    defaultMessage: 'Synchronizace byla spuštěna. Nové záznamy se v přehledu objeví během chvíle.',
  },
  synchronizeUpToDate: {
    id: 'manager.epsi.synchronizeUpToDate',
    defaultMessage: 'Stavová data jsou aktuální.',
  },
  synchronizeRunning: {
    id: 'manager.epsi.synchronizeRunning',
    defaultMessage: 'Stahování už probíhá, sledujte přehled.',
  },
  synchronizeForbidden: {
    id: 'manager.epsi.synchronizeForbidden',
    defaultMessage: 'Nemáte oprávnění spustit synchronizaci.',
  },
  synchronizeFail: {
    id: 'manager.epsi.synchronizeFail',
    defaultMessage: 'Synchronizaci se nepodařilo spustit.',
  },
  retryBtn: {
    id: 'manager.epsi.retryBtn',
    defaultMessage: 'Opakovat zpracování',
  },
  retryStarted: {
    id: 'manager.epsi.retryStarted',
    defaultMessage: 'Opakování bylo spuštěno. Stav záznamu se v přehledu změní během chvíle.',
  },
  retryForbidden: {
    id: 'manager.epsi.retryForbidden',
    defaultMessage: 'Nemáte oprávnění opakovat zpracování.',
  },
  retryConflict: {
    id: 'manager.epsi.retryConflict',
    defaultMessage: 'Zpracování tohoto záznamu nelze opakovat.',
  },
  retryUnavailable: {
    id: 'manager.epsi.retryUnavailable',
    defaultMessage: 'IS DMVS neodpovídá, opakování se nepodařilo spustit.',
  },
  retryFail: {
    id: 'manager.epsi.retryFail',
    defaultMessage: 'Opakování se nepodařilo spustit.',
  },
  stateWaiting: {
    id: 'manager.epsi.stateWaiting',
    defaultMessage: 'Načítají se aktualizace EPSI...',
  },
  stateFail: {
    id: 'manager.epsi.stateFail',
    defaultMessage: 'Aktualizace EPSI se nepovedlo načíst.',
  },
  stateEmpty: {
    id: 'manager.epsi.stateEmpty',
    defaultMessage: 'Nebyly nalezeny žádné aktualizace EPSI.',
  },
  detailTitle: {
    id: 'manager.epsi.detailTitle',
    defaultMessage: 'Aktualizace EPSI č. {id}',
  },
  detailStateWaiting: {
    id: 'manager.epsi.detailStateWaiting',
    defaultMessage: 'Načítá se detail aktualizace EPSI...',
  },
  detailStateFail: {
    id: 'manager.epsi.detailStateFail',
    defaultMessage: 'Detail aktualizace EPSI se nepovedlo načíst.',
  },
  filesTitle: {
    id: 'manager.epsi.filesTitle',
    defaultMessage: 'Soubory',
  },
  filesDocs: {
    id: 'manager.epsi.filesDocs',
    defaultMessage: 'Dokumentační',
  },
  filesSystem: {
    id: 'manager.epsi.filesSystem',
    defaultMessage: 'Systémové',
  },
  attachmentsEmpty: {
    id: 'manager.epsi.attachmentsEmpty',
    defaultMessage: 'Aktualizace nemá žádné přílohy.',
  },
  attachmentsDownloading: {
    id: 'manager.epsi.attachmentsDownloading',
    defaultMessage: 'Data se teprve stahují, přílohy zatím nejsou k dispozici.',
  },
  attachmentName: {
    id: 'manager.epsi.attachmentName',
    defaultMessage: 'Název souboru',
  },
  attachmentType: {
    id: 'manager.epsi.attachmentType',
    defaultMessage: 'Typ dokumentu',
  },
  attachmentCreated: {
    id: 'manager.epsi.attachmentCreated',
    defaultMessage: 'Datum nahrání',
  },
  attachmentSize: {
    id: 'manager.epsi.attachmentSize',
    defaultMessage: 'Velikost souboru',
  },
  downloadAllBtn: {
    id: 'manager.epsi.downloadAllBtn',
    defaultMessage: 'Stáhnout všechny přílohy',
  },
  downloadImportLog: {
    id: 'manager.epsi.downloadImportLog',
    defaultMessage: 'Protokol o importu',
  },
  downloadFail: {
    id: 'manager.epsi.downloadFail',
    defaultMessage: 'Soubor se nepodařilo stáhnout.',
  },
});

/** České názvy stavů PSPI evidence dle předávacího dokumentu BE (sekce 1). */
export const epsiStateMessages = defineMessages<EPSI_STATE>({
  [EPSI_STATE.WAITING_FOR_DOWNLOAD]: {
    id: 'manager.epsi.state.waitingForDownload',
    defaultMessage: 'Čeká na stažení',
  },
  [EPSI_STATE.DOWNLOADING]: {
    id: 'manager.epsi.state.downloading',
    defaultMessage: 'Stahuje se',
  },
  [EPSI_STATE.DOWNLOAD_FAILED]: {
    id: 'manager.epsi.state.downloadFailed',
    defaultMessage: 'Stažení selhalo',
  },
  [EPSI_STATE.WAITING_FOR_IMPORT]: {
    id: 'manager.epsi.state.waitingForImport',
    defaultMessage: 'Čeká na import',
  },
  [EPSI_STATE.IMPORTING]: {
    id: 'manager.epsi.state.importing',
    defaultMessage: 'Importuje se',
  },
  [EPSI_STATE.IMPORT_FAILED]: {
    id: 'manager.epsi.state.importFailed',
    defaultMessage: 'Import selhal',
  },
  [EPSI_STATE.IMPORTED]: {
    id: 'manager.epsi.state.imported',
    defaultMessage: 'Importováno',
  },
});

export const epsiTypeMessages = defineMessages<'S' | 'Z'>({
  S: {
    id: 'manager.epsi.type.S',
    defaultMessage: 'Stavový',
  },
  Z: {
    id: 'manager.epsi.type.Z',
    defaultMessage: 'Změnový',
  },
});

/**
 * Typ importu chodí z BE jako kód. Pro neznámou hodnotu vrací undefined,
 * volající pak zobrazí hodnotu tak, jak přišla.
 */
export const epsiTypeMessage = (type: string) =>
  type === 'S' || type === 'Z' ? epsiTypeMessages[type] : undefined;
